var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10995",
    "data-name": "Group 10995",
    transform: "translate(-123 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10044",
    "data-name": "Path 10044",
    d: "M12.42-22.433a6.8,6.8,0,0,1,2.155-.426,4.594,4.594,0,0,1,2.666.8,6.672,6.672,0,0,1,1.3,1.254,8.328,8.328,0,0,0-1.424,1.473,4.411,4.411,0,0,0-.816,2.581,4.766,4.766,0,0,0,.864,2.788,3.759,3.759,0,0,0,1.972,1.571A12.474,12.474,0,0,1,17.607-9.26q-1.619,2.447-3.214,2.447a5.562,5.562,0,0,1-1.747-.4,5.744,5.744,0,0,0-1.881-.4,4.778,4.778,0,0,0-1.784.42,4.588,4.588,0,0,1-1.65.42q-1.911,0-3.75-3.238A12.57,12.57,0,0,1,1.743-16.3,7.359,7.359,0,0,1,3.149-20.96a4.324,4.324,0,0,1,3.549-1.8,8.132,8.132,0,0,1,2.21.377,7.959,7.959,0,0,0,1.723.377A6.408,6.408,0,0,0,12.42-22.433Zm1.948-5.126a1.465,1.465,0,0,1,.061.28q.012.122.012.243a4.676,4.676,0,0,1-.365,1.7,5.052,5.052,0,0,1-1.157,1.717,3.708,3.708,0,0,1-1.351.9,6.439,6.439,0,0,1-1.291.207,5.585,5.585,0,0,1,.968-3.2A4.97,4.97,0,0,1,14.368-27.559Z",
    transform: "translate(133.558 436.167)",
    fill: "#191919"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.12190ac1e42b5aa23a660d75b37a069e.svg";
export { ForwardRef as ReactComponent };